<div class="tc-container">
  <main class="tc-content">
    <router-outlet></router-outlet>
  </main>
  <app-logout-modal [visible]="logoutModalVisible()" (confirm)="confirmLogout()" (cancel)="cancelLogout()">
  </app-logout-modal>
</div>